import script from "./InformationPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./InformationPopup.vue?vue&type=script&setup=true&lang=js"

import "./InformationPopup.vue?vue&type=style&index=0&id=61a7bb5c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61a7bb5c"]])

export default __exports__